import * as React from 'react';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import classNames from 'classnames';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import { ProfileDefault } from '../../../../types/uncinc_profile/profile';
import Placeholder from '../../../../assets/images/placeholder.svg';

import './style.scss';

interface DefaultProfileProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<ProfileDefault>;
  classes: string;
}

const DefaultProfileTeaser: React.FC<DefaultProfileProps> = ({ entity, classes, ...props }) => {
  const profile = entity.toJS();
  const profileName = profile.field_full_name[0].value;
  const profileFirstName = profileName.split(' ')[0];
  const profileDescription = profile.field_description?.[0]?.processed;
  const profileEmail = profile.field_email_address?.[0]?.value;
  const profileFunction = profile.field_function?.[0]?.entity.name[0].value;
  const imageStyles = profile.field_media_item?.[0]?.styles;
  const url = profile.path[0].alias;
  const telephone = profile.field_telephone?.[0]?.value;

  const src = [
    `${imageStyles?.ratio_1_1_sm || ''}`,
  ];

  return (
    <div className={classNames('DefaultProfileTeaser', classes)} {...props}>
      <div className="DefaultProfileTeaser__image">
        {imageStyles
          ? (
            <Image
              src={src}
              alt=""
              role="presentation"
            />
          )
          : <Image src={Placeholder} alt="" role="presentation" />}
      </div>
      <div className="DefaultProfileTeaser__description">
        <h4>{profileName}</h4>
        <p>{profileFunction}</p>
        <div className="DefaultProfileTeaser__links">
          {telephone && (
            <CoreLink href={`tel:${telephone}`}><span className="icon icon-phone icon-variant-2" /> {telephone}</CoreLink>
          )}
          <CoreLink href={`mailto:${profileEmail}`}><span className="icon icon-mail icon-variant-2" /> Mail {profileFirstName}</CoreLink>
          {profileDescription && <CoreLink href={url}><span className="icon icon-comment icon-variant-2" />Bio</CoreLink>}
        </div>
      </div>
      <div className="triangle triangle--medium" />
    </div>
  );
};

export default DefaultProfileTeaser;
